export const STANDALONE_OPERATOR_STORAGE_KEY =
  "lightbird:standalone-stock-count:operator";

export function readStandaloneOperator() {
  if (typeof window === "undefined") return "";
  return (
    window.localStorage.getItem(STANDALONE_OPERATOR_STORAGE_KEY)?.trim() ?? ""
  );
}

export function saveStandaloneOperator(operator: string) {
  const normalized = operator.trim();
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STANDALONE_OPERATOR_STORAGE_KEY, normalized);
  }
  return normalized;
}
